import React, { useCallback } from 'react';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { RootStackParamList } from '@/navigation/RootNavigator';
import { PostItemModal } from '@/components/residents/marketplace';

type PostItemRouteProp = RouteProp<RootStackParamList, 'PostItem'>;
type NavigationProp = StackNavigationProp<RootStackParamList, 'PostItem'>;

export const MobilePostItemScreen: React.FC = () => {
  const navigation = useNavigation<NavigationProp>();
  const route = useRoute<PostItemRouteProp>();
  const { propertyId, initialData, isEditMode, listingId } = route.params ?? {};

  const handleClose = useCallback(() => {
    if (navigation.canGoBack()) navigation.goBack();
  }, [navigation]);

  const handleSubmitSuccess = useCallback(() => {
    if (navigation.canGoBack()) navigation.goBack();
  }, [navigation]);

  return (
    <PostItemModal
      visible={true}
      onClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      propertyId={propertyId}
      initialData={initialData}
      isEditMode={isEditMode}
      listingId={listingId}
      asScreen
    />
  );
};

export default MobilePostItemScreen;
